import React from 'react';
import { Link } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const AboutFour = () => {
    const { t } = useTranslation('enterprise');
    const AboutSec = [
        {
            title: t('entrepriseMission.rse.engagementTitle1'),
            subtitle: t('entrepriseMission.rse.engagementSubtitle1'),
            list1: t('entrepriseMission.rse.engagementList1Point1'),
            list2: t('entrepriseMission.rse.engagementList1Point2'),
            list3: t('entrepriseMission.rse.engagementList1Point3'),
        }
    ]
    return (
        <div className="about-area about-style-4 rn-section-gap">
            <div className="container">
                <div className="row row--40 align-items-center">
                    <div className="col-lg-6">
                            <div className="video-btn">
                                <img src='/images/split/img-noiset-fonctionnement-4.png' alt='stakeholders' width={"500px"}/>
                            </div>
                    </div>
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            {AboutSec.map((data) => (
                            <div className="inner">
                            <h3 className="title" dangerouslySetInnerHTML={{__html: data.title}}></h3>
                            <p dangerouslySetInnerHTML={{__html: data.subtitle}}></p>    
                                <ul className="feature-list">
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <p className="text" style={{marginTop:"0px",marginBottom:"0px"}}  dangerouslySetInnerHTML={{__html: data.list1}}></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <p className="text"  style={{marginTop:"0px",marginBottom:"0px"}}  dangerouslySetInnerHTML={{__html: data.list2}}></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <p className="text"  style={{marginTop:"0px",marginBottom:"0px"}}  dangerouslySetInnerHTML={{__html: data.list3}}></p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="about-btn mt--30">
                                    <Link className="btn-default" to='/about-us'>{t('footer.quiSommesNous')}</Link>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutFour
